import { useQuery } from '@tanstack/react-query';
import { fetchObserveLocation, type ObserveLocationResponse } from '@apis/reports';

interface Params {
  siteId: string;
  areasIds: string[];
  date: string;
}

export function useObserveLocationQuery(params: Params) {
  const enabled = !!params.siteId && params.areasIds.length > 0 && !!params.date;
  return useQuery<ObserveLocationResponse>({
    queryKey: ['reports', 'observe-location', params.siteId, [...params.areasIds].sort().join(','), params.date] as const,
    queryFn: ({ signal }) => fetchObserveLocation(params, signal),
    enabled,
    staleTime: 5 * 60_000,
  });
}
